var firebaseConfig = {
    apiKey: "AIzaSyC9rHCvDNcBUX5mYOQ_EG7bswWAi32n2aM",
    authDomain: "accuracy-fbla.firebaseapp.com",
    databaseURL: "https://accuracy-fbla.firebaseio.com",
    projectId: "accuracy-fbla",
    storageBucket: "accuracy-fbla.appspot.com",
    messagingSenderId: "945856739408",
    appId: "1:945856739408:web:1684076c711c2431"
};

export default firebaseConfig;